/**
 * Legacy primary tenant (Alarms America / DEFAULT_ORGANIZATION_SLUG).
 * Must match backend settings.DEFAULT_ORGANIZATION_SLUG (see tenant_defaults.default_organization_slug).
 */
const DEFAULT_ORG_SLUG = (
  process.env.REACT_APP_DEFAULT_ORGANIZATION_SLUG || "default"
)
  .trim()
  .toLowerCase();

/**
 * True when the signed-in user belongs to the primary tenant org (slug match).
 */
export function userIsLegacyDefaultOrganization(user) {
  if (!user) return false;
  const slug = String(user.organization_slug || "")
    .trim()
    .toLowerCase();
  return Boolean(slug) && slug === DEFAULT_ORG_SLUG;
}
